import {createSelector} from '@reduxjs/toolkit'

const companyTrademarkSelector = createSelector(
    [state => state.components,
    state => state.primaryAgencyApplication.application?.businessLicenceData],
    (components, appData) => {
        
        return Object.assign({},
            components.companyTrademark,
            {companyTrademark : appData?.companyTrademark}
        )
    }
)

export const companyTrademarkSelect = state => ({
    companyTrademark: companyTrademarkSelector(state)
})
